module.exports = __webpack_public_path__ + "img/media-14.0ac93b8e.png";